import React, { useEffect, useState } from "react";
import { fetchContent } from "../../services/api";
import { DEFAULT_CONTENT } from "../../data/contentDefaults";
import "./AboutPage.css";

const FEATURE_ICONS = [
    `${process.env.PUBLIC_URL}/illustrations/about-map.svg`,
    `${process.env.PUBLIC_URL}/illustrations/about-cdr.svg`,
    `${process.env.PUBLIC_URL}/illustrations/about-scenarios.svg`,
];

const AboutPage = ({ onChangeTab }) => {
    const [content, setContent] = useState(DEFAULT_CONTENT.about);

    useEffect(() => {
        let cancelled = false;

        fetchContent()
            .then((data) => {
                if (!cancelled && data?.about) setContent(data.about);
            })
            .catch(() => {
                // Бэкенд недоступен — остаёмся на дефолтном тексте.
            });

        return () => {
            cancelled = true;
        };
    }, []);

    return (
        <div className="about-page">
            <div className="about-hero">
                <div className="about-hero-text">
                    <h1 className="about-title">{content.title}</h1>
                    <p className="about-subtitle">{content.subtitle}</p>
                    <p className="about-description">{content.description}</p>
                    <div className="about-actions">
                        <button
                            className="about-primary-button"
                            onClick={() => onChangeTab("map")}
                        >
                            Открыть карту
                        </button>
                        <button
                            className="about-link-button"
                            onClick={() => onChangeTab("methodology")}
                        >
                            Методика расчёта →
                        </button>
                    </div>
                </div>

                <div className="about-hero-card">
                    <h3 className="about-hero-card-title">
                        {content.heroCardTitle}
                    </h3>
                    <img
                        className="co2-diagram-image"
                        src={`${process.env.PUBLIC_URL}/co2-binding-diagram.svg`}
                        alt="Схема связывания CO₂: минеральные отходы и осадки выделяют Ca²⁺/Mg²⁺/Fe²⁺, которые реагируют с CO₃²⁻ с образованием устойчивых карбонатов"
                    />
                    <p className="co2-caption">{content.co2Caption}</p>
                </div>
            </div>

            <div className="about-features">
                <h2 className="about-features-title">
                    {content.featuresTitle}
                </h2>
                <div className="about-features-grid">
                    {content.features.map((feature, i) => (
                        <div
                            className="about-feature-card"
                            key={`${feature.title}-${i}`}
                        >
                            <div className="about-feature-body">
                                <div className="about-feature-index">
                                    {String(i + 1).padStart(2, "0")}
                                </div>
                                <h4 className="about-feature-title">
                                    {feature.title}
                                </h4>
                                <p className="about-feature-description">
                                    {feature.description}
                                </p>
                            </div>
                            <img
                                className="about-feature-icon"
                                src={FEATURE_ICONS[i % FEATURE_ICONS.length]}
                                alt=""
                                aria-hidden="true"
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default AboutPage;
